import { createBrowserRouter } from 'react-router-dom';
import ProtectedRoute from '../components/CommonComps/ProtectedRoute';
import ApplicationProvider from '../contexts/ApplicationProvider';
import ApplicationLayout from '../layouts/ApplicationLayout';
import GlobalLayout from '../layouts/GlobalLayout';
import Application from '../pages/application/Application';
import ApplicationDocuments from '../pages/application/ApplicationDocuments';
import ApplicationTracking from '../pages/application/ApplicationTracking';
import ApplicationUpdate from '../pages/application/ApplicationUpdate';
import Booking from '../pages/appointment/Booking';
import List from '../pages/appointment/List';
import AssociateRequests from '../pages/AssociateRequests';
import Associates from '../pages/Associates';
import AuditLogs from '../pages/AuditLogs';
import Clients from '../pages/Clients';
import Dashboard from '../pages/Dashboard';
import AssociateFeedback from '../pages/feedback/AssociateFeedback';
import ClientFeedback from '../pages/feedback/ClientFeedback';
import Appointment from '../pages/history/Appointment';
import BillingInfo from '../pages/history/BillingInfo';
import Purchase from '../pages/history/Purchase';
import Referrals from '../pages/history/Referrals';
import Reschedule from '../pages/history/Reschedule';
import Retain from '../pages/history/Retain';
import Transaction from '../pages/history/Transaction';
import Login from '../pages/Login';
import Notifications from '../pages/Notifications';
import Packages from '../pages/Packages';
import Profile from '../pages/Profile';
import RetainAgreements from '../pages/RetainAgreements';
import SentReminders from '../pages/SentReminders';
import Services from '../pages/Services';
import Session from '../pages/Session';
import Cities from '../pages/setup/Cities';
import Configurations from '../pages/setup/Configurations';
import Conversion from '../pages/setup/Conversion';
import Countries from '../pages/setup/Countries';
import Features from '../pages/setup/Features';
import Languages from '../pages/setup/Languages';
import PostalCodes from '../pages/setup/PostalCodes';
import Provinces from '../pages/setup/Provinces';
import RolePermissions from '../pages/setup/RolePermissions';
import Roles from '../pages/setup/Roles';
import Signup from '../pages/Signup';
import Vacations from '../pages/Vacations';

// creating the router here
export const router = createBrowserRouter([
  /**
   * SIDE NAVBAR ROUTES STARTS HERE
   */
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <GlobalLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
    ],
  },

  {
    path: '/appointment',
    element: (
      <ProtectedRoute>
        <GlobalLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: 'booking', element: <Booking /> },
      { path: 'list', element: <List /> },
    ],
  },

  {
    path: '/setup',
    element: (
      <ProtectedRoute>
        <GlobalLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: 'configurations', element: <Configurations /> },
      { path: 'roles', element: <Roles /> },
      { path: 'features', element: <Features /> },
      { path: 'role-permissions', element: <RolePermissions /> },
      { path: 'languages', element: <Languages /> },
      { path: 'countries', element: <Countries /> },
      { path: 'provinces', element: <Provinces /> },
      { path: 'cities', element: <Cities /> },
      { path: 'postal-codes', element: <PostalCodes /> },
      { path: 'conversion', element: <Conversion /> },
      { path: 'features', element: <Features /> },
    ],
  },

  {
    path: '/packages',
    element: (
      <ProtectedRoute>
        <GlobalLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Packages />,
      },
    ],
  },

  {
    path: '/vacations',
    element: (
      <ProtectedRoute>
        <GlobalLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Vacations />,
      },
    ],
  },

  {
    path: '/services',
    element: (
      <ProtectedRoute>
        <GlobalLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Services />,
      },
    ],
  },

  {
    path: '/history',
    element: (
      <ProtectedRoute>
        <GlobalLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: 'appointment', element: <Appointment /> },
      { path: 'reschedule', element: <Reschedule /> },
      { path: 'referrals', element: <Referrals /> },
      { path: 'retain', element: <Retain /> },
      { path: 'transaction', element: <Transaction /> },
      { path: 'purchase', element: <Purchase /> },
      { path: 'bills', element: <BillingInfo /> },
    ],
  },

  {
    path: '/feedbacks',
    element: (
      <ProtectedRoute>
        <GlobalLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: 'client', element: <ClientFeedback /> },
      { path: 'associate', element: <AssociateFeedback /> },
    ],
  },

  {
    path: '/retain-agreements',
    element: (
      <ProtectedRoute>
        <GlobalLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <RetainAgreements />,
      },
    ],
  },

  {
    path: '/sent-reminders',
    element: (
      <ProtectedRoute>
        <GlobalLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <SentReminders />,
      },
    ],
  },

  {
    path: '/associates',
    element: (
      <ProtectedRoute>
        <GlobalLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Associates />,
      },
    ],
  },

  {
    path: '/associate-requests',
    element: (
      <ProtectedRoute>
        <GlobalLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <AssociateRequests />,
      },
    ],
  },

  {
    path: '/clients',
    element: (
      <ProtectedRoute>
        <GlobalLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Clients />,
      },
    ],
  },

  {
    path: '/audit-logs',
    element: (
      <ProtectedRoute>
        <GlobalLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <AuditLogs />,
      },
    ],
  },
  /**
   * SIDE NAVBAR ROUTES ENDS HERE
   */

  /**
   * OTHER ROUTES (WITH LAYOUT) STARTS HERE
   */
  {
    path: '/notifications',
    element: (
      <ProtectedRoute>
        <GlobalLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Notifications />,
      },
    ],
  },

  {
    path: '/profile',
    element: (
      <ProtectedRoute>
        <GlobalLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Profile />,
      },
    ],
  },

  {
    path: '/application',
    element: (
      <ProtectedRoute>
        <ApplicationLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: 'update',
        element: (
          <ApplicationProvider>
            <ApplicationUpdate />
          </ApplicationProvider>
        ),
      },
      {
        path: 'tracking',
        element: (
          <ApplicationProvider>
            <ApplicationTracking />
          </ApplicationProvider>
        ),
      },
    ],
  },
  /**
   * OTHER ROUTES (WITH LAYOUT) ENDS HERE
   */

  /**
   * OTHER ROUTES (WITHOUT LAYOUT) STARTS HERE
   */
  {
    path: '/session/:sessionId',
    element: (
      <ProtectedRoute>
        <Session />
      </ProtectedRoute>
    ),
  },

  {
    path: '/',
    element: <Login />,
  },

  {
    path: '/signup',
    element: <Signup />,
  },

  {
    path: '/application',
    children: [
      {
        index: true,
        element: (
          <ApplicationProvider>
            <Application />
          </ApplicationProvider>
        ),
      },

      {
        path: 'documents',
        element: <ApplicationDocuments />,
      },

      {
        path: ':uuid',
        element: <ApplicationTracking />,
      },

      // {
      //   path: 'update',
      //   element: (
      //     <ApplicationProvider>
      //       <ApplicationUpdate />
      //     </ApplicationProvider>
      //   ),
      // },
    ],
  },
  /**
   * OTHER ROUTES (WITHOUT LAYOUT) ENDS HERE
   */
]);
